import { render, staticRenderFns } from "./GroupsPushAddress.vue?vue&type=template&id=0ceca0c4&"
import script from "./GroupsPushAddress.vue?vue&type=script&lang=ts&"
export * from "./GroupsPushAddress.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports